import { showToast } from 'vant';

export function showPassedToast(messageOrOptions, options = {}) {
  if (messageOrOptions && typeof messageOrOptions === 'object' && !Array.isArray(messageOrOptions)) {
    return showToast({
      ...messageOrOptions,
      icon: 'passed'
    });
  }

  return showToast({
    message: messageOrOptions,
    icon: 'passed',
    ...options
  });
}
